import { render, staticRenderFns } from "./tipsList.vue?vue&type=template&id=600a2dfd"
import script from "./tipsList.vue?vue&type=script&lang=js"
export * from "./tipsList.vue?vue&type=script&lang=js"
import style0 from "./tipsList.vue?vue&type=style&index=0&id=600a2dfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports